export var SurveyAnswerSentiment;
(function (SurveyAnswerSentiment) {
    SurveyAnswerSentiment["POSITIVE"] = "POSITIVE";
    SurveyAnswerSentiment["NEUTRAL"] = "NEUTRAL";
    SurveyAnswerSentiment["NEGATIVE"] = "NEGATIVE";
})(SurveyAnswerSentiment || (SurveyAnswerSentiment = {}));
export var SurveyAiState;
(function (SurveyAiState) {
    SurveyAiState["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    SurveyAiState["PENDING"] = "PENDING";
    SurveyAiState["DONE"] = "DONE";
    SurveyAiState["FAILED"] = "FAILED";
})(SurveyAiState || (SurveyAiState = {}));
export var SurveyReviewState;
(function (SurveyReviewState) {
    SurveyReviewState["OPEN"] = "OPEN";
    SurveyReviewState["REVIEWED"] = "REVIEWED";
})(SurveyReviewState || (SurveyReviewState = {}));
/** Why a reply needs a look - the red chips on the module's Submissions tab; only a reply with a score can have one. */
export var SurveyAttentionType;
(function (SurveyAttentionType) {
    /** The reply's score is below 50. */
    SurveyAttentionType["LOW_SCORE"] = "LOW_SCORE";
    /** One of the reply's answers reads negative, whatever its score. */
    SurveyAttentionType["NEGATIVE_COMMENT"] = "NEGATIVE_COMMENT";
})(SurveyAttentionType || (SurveyAttentionType = {}));
